import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const SESSION_LIST_API_URL = "api/fastapi/session-history/";
const MESSAGES_LIST_API_URL = "api/fastapi/chat-history/"; 
const ARCHIVED_MESSAGES_API_URL = "api/fastapi/sessions/archived/"; 


export const fetchSessionsList = createAsyncThunk(
    "collecteazeAi/fetchSessionsList",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) {
                return;
            }
            const response = await axios.get(SESSION_LIST_API_URL, {
                params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);
export const fetchSessionsMessages = createAsyncThunk(
    "collecteazeAi/fetchSessionsMessages",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) {
                return;
            }
            const response = await axios.get(MESSAGES_LIST_API_URL, {
                params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data?.data?.messages || [];
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);


export const fetchArchiveSessionsList = createAsyncThunk(
    "collecteazeAi/fetchArchiveSessionsList",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) {
                return;
            }
            const response = await axios.get(ARCHIVED_MESSAGES_API_URL, {
                params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data?.data || [];
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);


const initialState = {
    // all sessions
    all_sessions: [],
    sessions_loading: false,

    // current session
    current_session: null,

    // all messages
    all_messages: [],
    messages_loading: false,

    // all archived sessions
    all_archived_sessions: [],
    archived_sessions_loading: false
};
const collecteazeAiSlice = createSlice({
    name: "collecteazeAi",
    initialState,
    reducers: {
        setCurrentSession: (state, action) => {
            state.current_session = action.payload
        },
        appendCurrentMessage: (state, action) => {
            state.all_messages = [...state.all_messages, ...action.payload];
        }

    },
    extraReducers: (builder) => {
        builder
            // fetch all sessions
            .addCase(fetchSessionsList.pending, (state) => {
                state.sessions_loading = true;
            })
            .addCase(fetchSessionsList.fulfilled, (state, action) => {
                state.sessions_loading = false;
                state.all_sessions = action.payload;
            })
            .addCase(fetchSessionsList.rejected, (state, action) => {
                state.sessions_loading = false;
                state.all_sessions = [];
            })

            // all messages
            .addCase(fetchSessionsMessages.pending, (state) => {
                state.messages_loading = true;
            })
            .addCase(fetchSessionsMessages.fulfilled, (state, action) => {
                state.messages_loading = false;
                state.all_messages = action.payload;
            })
            .addCase(fetchSessionsMessages.rejected, (state, action) => {
                state.messages_loading = false;
                state.all_messages = [];
            })


            // fetch archived sessions
            .addCase(fetchArchiveSessionsList.pending, (state) => {
                state.archived_sessions_loading = true;
            })
            .addCase(fetchArchiveSessionsList.fulfilled, (state, action) => {
                state.archived_sessions_loading = false;
                state.all_archived_sessions = action.payload;
            }
            )
            .addCase(fetchArchiveSessionsList.rejected, (state, action) => {
                state.archived_sessions_loading = false;
                state.all_archived_sessions = [];
            });


    },
});

export default collecteazeAiSlice.reducer;
export const { setCurrentSession, appendCurrentMessage } = collecteazeAiSlice.actions;
